import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { AddTOTPForm } from '#components/patterns/totp/add/AddTOTPForm.tsx';
import { page, Titled } from '#util/title.ts';
import styles from './AddTOTPModal.module.css';

/**
 * {@link AddTOTPModal} shows a form for adding a new totp authenticator.
 */
export function AddTOTPModal() {
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();

  function returnToUserSettings() {
    void navigate('..', { replace: true });
  }

  const modalRef = useRef(null);

  return (
    <Modal isOpen={true} onClose={returnToUserSettings} ref={modalRef}>
      <Titled title={() => page('Add Authenticator')}>
        <ModalHeader>Add authenticator</ModalHeader>
        <ModalBody className={styles.AddTOTPModal}>
          <AddTOTPForm
            onSuccess={returnToUserSettings}
            smallQR={true}
            allowCustomName={true}
            onError={() => {
              setHasError(true);
            }}
          />
        </ModalBody>
        <ModalFooter>
          {hasError ?
            <Button variant="secondary" onClick={returnToUserSettings}>
              Close
            </Button>
          : <ConfirmButtonGroup
              variant="right"
              primaryButton={
                <Button type="submit" form="register-mfa">
                  Add
                </Button>
              }
              secondaryButton={
                <Button variant="link" onClick={returnToUserSettings}>
                  Cancel
                </Button>
              }
            />
          }
        </ModalFooter>
      </Titled>
    </Modal>
  );
}
